// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Taiwan */
const TW = /^(?:(?:40001[0-2]|9[0-8]\d{4})\d{3})$/;

export default TW;
